export default __webpack_public_path__ + "static/media/Eighth.60f95ea2.png";